"use client";

import Image from "next/image";
import Link from "@/components/ui/Link";
import { MessageIcon } from "../ui/message-icon";
import PlayButton from "../ui/playbutton";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';

type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};

type Props = {
  title?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  imageMetadata?: ImageMetadata;
};

export const VerticalMediumVideoNews = ({
  title = { hidden: false, value: "மகன், சகோதரர் மற்றும் ஒரு கேப்டன்: தி லெகசி ஆஃப் ஹான்சி குரோனியே", customClass: "" },
  timeAgo = { hidden: false, value: "May 17, 2023", customClass: "" },
  imageSrc = { hidden: false, value: FALLBACK_IMAGE, customClass: "" },
  slug,
  imageMetadata,
}: Props) => {
  const titleValue = title?.value || "";
  const timeAgoValue = getTimeAgo(timeAgo?.value);
  const imageSrcValue = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;

  const content = (
    <div className="flex flex-col bg-F8F8F8 overflow-hidden p-4 gap-4">
      {/* IMAGE */}
      {!imageSrc?.hidden && (
        <div>
          <div className="relative w-full aspect-[16/9] overflow-hidden">
            <div className="absolute bottom-2 right-2 z-10">
              <PlayButton />
            </div>
            <Image
              src={imageSrcValue}
              alt={titleValue}
              fill
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 300px"
              className={`object-cover w-full h-full ${imageSrc?.customClass || ""}`}
              style={getFocusPointStyle(imageMetadata)}
              loading="lazy"
              placeholder="blur"
              blurDataURL={BLUR_PLACEHOLDER}
            />
          </div>
        </div>
      )}

      {/* CONTENT */}
      <div className="flex flex-col gap-3">
        {/* Title */}
        {!title?.hidden && (
 <h3 className={`text-16-tamil-700 leading-[1.4] text-1B1B1B ${title?.customClass || ""}`}>
            {titleValue}
          </h3>
        )}

        {/* Footer */}
        <div className="flex justify-between items-center">
          {!timeAgo?.hidden && (
            <span className={`text-12-tamil-500 text-1B1B1B ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>
          )}
          <MessageIcon
            id="message-icon-1"
            slug={slug}
            category={BOOKMARK_CATEGORIES.VIDEOS}
            title={titleValue}
            thumbnailUrl={imageSrcValue}
            articleUrl={slug ? `/${slug}` : undefined}
          />
        </div>
      </div>
    </div>
  );

  if (slug) {
    return (
      <Link href={`/${slug}`} className="block hover:bg-gray-100 transition-colors cursor-pointer">
        {content}
      </Link>
    );
  }

  return content;
};
